$(document).ready(function() {
  $('.menu-button').click(function(){
   $('#menu-drawer-overlay').addClass('active').fadeIn();
   $('.menu-drawer').addClass('active');
    $('body').addClass('overflow-hidden');
    if($('#gorgias-chat-container').length > 0){
      $('#gorgias-chat-container').addClass('hidden');
    }
  });
  $('.menu-drawer-close,.menu-drawer-overlay').click(function(){
   $('.menu-drawer').removeClass('active');
    $('#menu-drawer-overlay').removeClass('active').fadeOut();
    $('body').removeClass('overflow-hidden');
    $('#gorgias-chat-container').removeClass('hidden');
  });

  $('.menu-drawer-link.has-submenu').click(function(e){
    e.preventDefault();
   $(this).next('.menu-drawer-body_subnav').addClass('active') 
  });
  $('.menu-drawer-back').click(function(e){
    e.preventDefault();
   $(this).parents('.menu-drawer-body_nav').removeClass('active');
  });

  $('.menu-drawer-link.has_sub-dropdown-menu').click(function (e) {
    e.preventDefault();
    $(this).parent('.menu-drawer-li').siblings('.menu-drawer-li.active').removeClass('active').find('.sub-dropdown-menu').slideUp();
    $(this).parent('.menu-drawer-li').toggleClass('active').find('.sub-dropdown-menu').slideToggle();
  });

  if (window.matchMedia('(max-width: 749px)').matches){
   $('.footer-menu_item-title').click(function(){
     $(this).toggleClass('active');
     $(this).next('ul').slideToggle();
    });   
  }

  // --------------- Collection Page
  if($('.collection-hero__text-wrapper .collection-hero__close').length > 0){
    $('.collection-hero__text-wrapper .collection-hero__close').click(function (event) {
      event.preventDefault();
      $(this).parents('.collection-hero__row').fadeOut();
    });
  }

  if($('.facet_block---wrap').length > 0){
    $(document).on('click','.facet_block---wrap .facet_block---toggle',function (event) {
      event.preventDefault();
      $(this).parent('.facet_block---wrap').siblings('.facet_block---wrap.open').removeClass('open').find('.facet_block---content').slideUp();
      $(this).parent('.facet_block---wrap').toggleClass('open');
      $(this).siblings('.facet_block---content').slideToggle();
    });

    $(document).mouseup(function (e) {
      if($(window).width() < 750){
       if (!$('#FacetFiltersFormMobile').is(e.target) && $('#FacetFiltersFormMobile').has(e.target).length === 0){
         $(".facet_block---wrap").removeClass("open");
         $('.facet_block---content').slideUp();
       } 
      }else{
       if (!$('.facet_block---wrap').is(e.target) && $('.facet_block---wrap').has(e.target).length === 0){
         $(".facet_block---wrap").removeClass("open");
         $('.facet_block---content').slideUp();
       }
      }
    });    
  }

  if($('.facet_search_bar').length > 0){
    $(document).on('click','#facet_search_bar-toggle,#facet_search_bar-close',function (event) {
      event.preventDefault();
      $(this).parents('.facet_search_bar').toggleClass('open_search');
    });
  }
  
  $(document).on('click','#FacetFiltersFormMobile #filter_close',function (event) {
    event.preventDefault();
    $('.mobile-facets__open-wrapper').click();
  });

  $(document).on('click','[data-info-popup]',function (e) {
    e.preventDefault();
    var target = $(this).data('info-popup-target');
    $('.info__popup[data-info-popup-model="'+ target +'"]').fadeIn();
    $('body').addClass('overflow-hidden');
  });

  $(document).on('click','.info__popup-close',function (e) {
    e.preventDefault();
    var ytIframe = $(this).parents('.info__popup-container').find('.video-frame-wrapp iframe')[0];
    if (ytIframe && ytIframe.src.includes('youtube')){
      ytIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
    $(this).parents('.info__popup').fadeOut();
    $('body').removeClass('overflow-hidden');
  });


  /* Product Card */
  $(document).on('click','.product-card-wrapper .card__media-hover',function () {
    if($(window).width() < 750){
      $(this).toggleClass('show_second_img');
    }
  });
  

  if($('#grid-view-option').length > 0){
    $(document).on('click','#grid-view-option .grid-view-option-btn',function (event) {
      event.preventDefault();
      $('#grid-view-option .grid-view-option-btn').removeClass('active');
      $(this).addClass('active');
      
      var grid = $(this).data('grid-view');
      
      localStorage.setItem("Grid__Layout", grid);
      
      $('#product-grid').attr('data-product-grid',grid);
    });
    
    var GridLayout = localStorage.getItem("Grid__Layout");
    $('#grid-view-option .grid-view-option-btn[data-grid-view="'+ GridLayout +'"]').click();
  }
  
  // --------------- Collection Page
  
  if($('[data-video-wrap]').length > 0){
    $('[data-video-wrap]').on("click",function(){
      if($(this).hasClass('active')){
        $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        $(this).removeClass('active');
      }else{
        $('[data-video-wrap]').each(function(){
          $(this).removeClass('active');
          $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        });
        $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        $(this).addClass('active');
      }
    });
  }


  $(window).scroll(function(){
    var scrolll_top = $('.announcement-bar-section').length > 0 ? $('.announcement-bar-section').height() : 0;
    if ($(this).scrollTop() > scrolll_top) {
      if(!$('.section-header').hasClass('scrolled')){
         $('.section-header').addClass('scrolled');
        $('#MainContent').css('padding-top', $('.section-header').height()+'px');
      }
    } else {
       $('.section-header').removeClass('scrolled');
      $('#MainContent').css('padding-top', '0');
    }
  });
  $(window).scroll();


  // --------------- Product Page

  if($('.main_product_tabs').length > 0){
    $(document).on("click",".main_product_tabs .tab__toggle:not(.active)",function(e){
      e.preventDefault();
      $(this).addClass("active").siblings('.tab__toggle').removeClass("active");
      var id = $(this).data("tab-target");
      $('.main_product_tabs_wrap .main_product_tab_block').hide();
      $('.main_product_tabs_wrap .main_product_tab_block[data-tab-id="' + id + '"]').fadeIn();
    });
  }

  if($('#goto-description').length > 0){
    $('#goto-description').click(function(e) {
      e.preventDefault();
      $('[data-tab-target="product-tab-1"]').trigger('click');
      $('html,body').animate({scrollTop: $('[data-tab-target="product-tab-1"]').offset().top-100},'slow');
    })
  }

  if($('.product__addons .product__addons-slider').length > 0){
    var product__addons = new Swiper('.product__addons .product__addons-slider',{
      loop: false,
      slidesPerView: 2.2,
      spaceBetween: 15,
      freeMode: true,
      mousewheel:{
        forceToAxis: true
      },
      navigation: {
        prevEl: ".product__addons .product__addons_head .addons-prev",
        nextEl: ".product__addons .product__addons_head .addons-next",
      },
      breakpoints: {
        576: {
          slidesPerView: 4,
        },
        750: {
          slidesPerView: 2.5,
        },
        990: {
          slidesPerView: 3,
        },
        1201: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
      mousewheel:{
        forceToAxis: true
      }
    });
  }

  // --------------- Product Page

  // --------------- Video Section Two
  if($('.section-video-two').length > 0){
    $('.section-video-two [data-video-toggler]').on("click",function(){
      if($(this).parents('.section-video-two').hasClass('active')){
        $(this).parents('.section-video-two').find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        $(this).parents('.section-video-two').removeClass('active');
      }else{
        $(this).parents('.section-video-two').find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        $(this).parents('.section-video-two').addClass('active');
      }
    });
  }
  // --------------- Video Section Two

  // --------------- Related Product
  if($('.related-products').length > 0){
    var check_related_products = setInterval(function (){
      if($('.related-products .related-products__slider').length > 0){
          var main_related_products = new Swiper('.related-products .related-products__slider',{
           slidesPerView: 'auto',
           spaceBetween: 12,
           freeMode: true,
           mousewheel:{
            forceToAxis: true
          }, 
           breakpoints: {
             750: {
               spaceBetween: 20
             }
           },
           mousewheel:{
             forceToAxis: true
           }
        });
        clearInterval(check_related_products);
      }
    },1000);
  }
  // --------------- Related Product


  // --------------- Faq
  if($('[data-faq-block]').length > 0){
    $('[data-faq-toggle]').on("click",function(){
      $(this).parents('[data-faq-block]').toggleClass('active');
      $(this).parents('[data-faq-block]').find('[data-faq-content]').slideToggle();
    });
  }
  // --------------- Faq

  // --------------- Main FAQ
  if($('.main-faq .main-faq_sections .main-faq_section').length > 0){
    $('.main-faq .main-faq_sidebar a.main-faq_sidebar_item').click(function(e) {
      e.preventDefault();
      var target = $(this).attr('href');
      $(this).addClass('active').siblings().removeClass('active');
      $('html,body').animate({scrollTop: $('.main-faq .main-faq_sections '+ target).offset().top-100},'slow');
    });
    $(window).on('scroll',function () {
      var windscroll = $(window).scrollTop();
      $('.main-faq .main-faq_sections .main-faq_section').each(function () {
        var id = $(this).attr('id');
        if ($(this).position().top + 50 <= windscroll - 0) {
          $('.main-faq .main-faq_sidebar a.main-faq_sidebar_item.active').removeClass('active');
          $('.main-faq .main-faq_sidebar a.main-faq_sidebar_item[href="#'+id+'"]').addClass('active');
        }
      });
    });
  }
  // --------------- Main FAQ
  
  $('body').on('click', '.js-submitBtn[name="checkout"], .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], .js-submitBtn[href="/checkout"]', function () {
    if ($('input#terms:checked').length == 0) {
      alert(window.cartStrings.cartConfirmation);
      return false;
    }
  });

  $('body').on('click', '.chat_button', function (e) {
    e.preventDefault();
    GorgiasChat.open();
  });

  // slider js
  const swiper = new Swiper('.custom-swiper', {
    loop: true,
    slidesPerView: 'auto',
    autoplay: false,
    centeredSlides: true,
    navigation: {
      nextEl: '.next-button',
      prevEl: '.prev-button',
    },
    on: {
      init: function () {
        handleSlideChange.call(this);
      },
      slideChange: function () {
        handleSlideChange.call(this);
      },
    },
  });

  function handleSlideChange() {
    // Hide content box for all slides
    this.slides.forEach((slide) => {
      const box = slide.querySelector('.content-box');
      if (box) {
        box.style.display = 'none';
      }
    });

    // Show content box for active slide
    const activeSlide = this.slides[this.activeIndex];
    if (activeSlide) {
      const activeBox = activeSlide.querySelector('.content-box');
      if (activeBox) {
        activeBox.style.display = 'flex';
      }
    }
  }

  // Shop the look popup
  var currentURL = window.location.href;
  if (currentURL.includes('#') && $('.single_grid.popup_opener_JS .title_with_button .button').length){
    var popup_attr_value = currentURL.split('#')[1];
    $('.single_grid.popup_opener_JS .title_with_button .button[href="#' + popup_attr_value + '"]').click();
  }

  // --------------- Breadcrumb with banner
  if($('.breadcrumb-with-banner .breadcrumb-with-banner-close').length > 0){
    $('.breadcrumb-with-banner .breadcrumb-with-banner-close').click(function (event) {
      event.preventDefault();
      $(this).parents('.breadcrumb-with-banner-row').fadeOut();
    });
  }
  // --------------- Breadcrumb with banner

  if($('.cart-page-review-slider').length > 0){
    var cart_page_review = new Swiper('.cart-page-review-slider',{
      loop: true,
      slidesPerView: 1,
      spaceBetween: 22,
      mousewheel:{
        forceToAxis: true
      },
      navigation: {
        prevEl: ".cart-page-review-slider .swiper-prev-button",
        nextEl: ".cart-page-review-slider .swiper-next-button",
      }
    });
  }

   // --------------- Press on Infinite Scroll
  if($('.press-on-scroll').length > 0){
    if ($(window).width() <= 749) {
      var press_marquee_speed = $('.press-on-scroll .press-on-scroll-bar').data('scroll-speed');
      $('.press-on-scroll .press-on-scroll-bar').marquee({
        gap: 0,
        speed: press_marquee_speed*1000,
        delayBeforeStart: 1000,
        direction: 'left',
        duplicated: true
      });
    }
  }

  if($('.announcementbar-timer').length > 0 && typeof window.start_date != 'undefined' && typeof window.end_date != 'undefined'){
    var countDownDate = new Date(window.end_date).getTime();
    var startCountDownDate = new Date(window.start_date).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().toLocaleString("en-US", {timeZone: "Europe/Copenhagen"});
      now = new Date(now).getTime();

      if (now >= startCountDownDate && now <= countDownDate) {
        // Find the distance between now and the count down date
        var distance = countDownDate - now;      
          
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
        var days = formatTime(days);
        days = String(days).padStart(2, '0');
        var hours = formatTime(hours);
        hours = String(hours).padStart(2, '0');
        var minutes = formatTime(minutes);
        minutes = String(minutes).padStart(2, '0');
        var seconds = formatTime(seconds);
        seconds = String(seconds).padStart(2, '0');
  
        function formatTime(time){
          return time < 10 ? `${time}` : time;
        }

        var day_text = window.announStrings.days;
        var hours_text = window.announStrings.hours;
        var minutes_text = window.announStrings.minutes;
        var seconds_text = window.announStrings.seconds;
          
        // Output the result in an element with id="demo"
        var html = "<span class='time_day'><span class='timer_number h5 m-0'>" + days + "</span><span class='timer_text'>" + day_text + "</span></span><span class='time_dots hidden'>:</span><span class='time_hours'><span class='timer_number h5 m-0'>" + hours + "</span><span class='timer_text'>" + hours_text + "</span></span><span class='time_dots hidden'>:</span><span class='time_minutes'><span class='timer_number h5 m-0'>" + minutes + "</span><span class='timer_text'>" + minutes_text + "</span></span><span class='time_dots hidden'>:</span><span class='time_seconds'><span class='timer_number h5 m-0'>" + seconds + "</span><span class='timer_text'>" + seconds_text +"</span>" + "</span>";
        $('.announcementbartimer').html(html);
        $('.announcementbar-timer').removeClass('hidden');
      } else {  
        // If the count down is over, write some text 
        clearInterval(x);
        $('.announcementbartimer').html(' ');
        $('.announcementbar-timer').addClass('hidden');
      }
    }, 1000);
  }
  
});

// MD CODE START
$(document).on('click','.popup_opener_JS',function(){
  if($('.popup_content_main').length){
    var popup_data_HTML = $(this).find('.popup_data_main_JS').html();
    $('.popup_content_main .popup_content_data').html(popup_data_HTML);
    $('.popup_content_main').removeClass('hidden');
    var data_href = $(this).attr('data_href');
    if (data_href){
      history.pushState(null, null, data_href);
    }
  }
});

function closePopup(){
  if($('.popup_content_main').length){
    $('.popup_content_main').addClass('hidden');
    $('.popup_content_main .popup_content_data').html('');
    var currentURL = window.location.href;
    if (currentURL.includes('#')) {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  }
}

$(document).on('click','.popup_content_inner .close',function(){
  closePopup();
});

$(document).on('mouseup',function(e){
  var container = $(".popup_content_main .popup_data_main");
  if (!container.is(e.target) && container.has(e.target).length === 0){
    closePopup();
  }
});
// MD CODE END